import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { UrlService } from "src/app/miscellaneous/url.service";
import { DataService } from "src/app/services/data.service";
import { MenuService } from "src/app/services/menu-service.service";
import { timeout, catchError, of, switchMap, take, filter, tap, } from 'rxjs';

export interface IData {
  data?: any[];
  props?: any;
}

@Component({
  selector: "asset-publisher",
  templateUrl: "./asset-publisher.component.html",
  styleUrls: ["./asset-publisher.component.scss"],
  providers: [UrlService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetPublisherComponent implements OnInit {
  private _data: IData | undefined;

  @Input() set data(value: IData) {
    this._data = value;
    this.cdr.markForCheck(); //this.cdr.detectChanges();
  }
  get data(): IData {
    return <IData>this._data;
  }

  @Input() template!: string;
  @Input() name!: string;
  @Input() endpoint!: string;
  @Input() props!: any;

  id: string | undefined | false;
  static compName = "AssetPublisher";

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private urlService: UrlService,
    private menuService: MenuService
  ) { }




  ngOnInit(): void {

    if (!this.props?.forceFetchData) {

      this.menuService.menuItem$
        .pipe(
          filter((item) => !!item),
          take(1),
          switchMap((item) => {
            let endpoint = this.endpoint;
            if (item && this.props?.concatKey) {
              endpoint = this.endpoint + "/" + item.key;
            } else {
              const id = this.urlService.getUrlId();
              endpoint = id ? this.endpoint + "/" + id : this.endpoint;
              endpoint = this.endpoint + "/" + item!.key;
            }
            return this.dataService
              .getData(endpoint)
              .pipe(tap((data) => (this.data = { data: data, props: this.props })));
          })
        )
        .subscribe();

    } else {

      this.menuService.menuItem$
        .pipe(
          take(1),
          timeout(0),
          catchError(() => of(null)),
          switchMap((item) => {

            let endpoint = this.endpoint;

            const id = this.urlService.getUrlId();
            endpoint = id
              ? `${this.endpoint}/${id}`
              : this.endpoint;

            return this.dataService.getData(endpoint);
          })
        )
        .subscribe((data) => {
          this.data = { data: data, props: this.props };
        });
    }
  }


}
